import {useState} from "react";
import PropertyLibrary from "components/PropertyLibrary";
import materialDefault from "images/ic_material.png";
import {ChromePicker} from "react-color";
import styles from "./index.module.scss";
import bluesky from "images/bluesky.png";
import {ReactComponent as DefaultIcon} from "images/ic_default.svg";
import {ReactComponent as TextureIcon} from "images/ic_texture.svg";
import {ReactComponent as ColorIcon} from "images/ic_color.svg";

const BackgroundInput = ({name, active, propertyName, inputOnChange, thumbnail, objectColor, colorOnChange}) => {
  const [isLibraryOpened, setIsLibraryOpened] = useState(false);
  const [colorBoxOn, setColorBoxOn] = useState(false);
  const [textureImg, setTextureImg] = useState(materialDefault);

  const handleLibrary = () => {
    if (propertyName === "map" || propertyName === "normalMap") {
      setIsLibraryOpened(!isLibraryOpened);
    }
  };

  // color
  const onClickColorBox = () => {
    setColorBoxOn(!colorBoxOn);
  };
  //reset background
  const resetBackground = () => {
    inputOnChange("DefaultTexture");
  };

  let title;
  if (name === "DefaultTexture") {
    title = "Default";
    thumbnail = bluesky;
  } else if (name === "BackgroundTexture") {
    title = "Texture";
  } else if (name === "BackgroundColor") {
    title = "Color";
  } else {
    title = name;
  }

  return (
    <div className={`${styles.container} ${title === active ? styles.active : ""}`}>
      {title === "Color" ? (
        <>
          <ColorPart />
          {colorBoxOn && (
            <div className={styles.color_picker}>
              <div onClick={onClickColorBox} className={styles.close_button} />
              <ChromePicker color={objectColor} onChange={e => colorOnChange(name, e)} />
            </div>
          )}
          <p className={styles.title}>{title}</p>
        </>
      ) : (
        <>
          {title === "Default" ? <DefaultPart /> : <TexturePart />}
          {isLibraryOpened && (
            <PropertyLibrary name={name} propertyName={propertyName} onClickItem={inputOnChange} onClickClose={handleLibrary} />
          )}
          <p className={styles.title}>{title}</p>
        </>
      )}
    </div>
  );

  function DefaultPart() {
    return (
      <>
        <div className={styles.box} onClick={resetBackground}>
          {title === active ? (
            <img src={thumbnail ? thumbnail : materialDefault} alt="material" />
          ) : (
            <DefaultIcon style={{width: "24px", height: "24px"}} />
          )}
        </div>
      </>
    );
  }

  function TexturePart() {
    return (
      <>
        <label className={styles.input_wrapper}>
          <input
            className={styles.input_file}
            type="file"
            onChange={e => {
              const imgUrl = window.URL.createObjectURL(e.target.files[0]);
              setTextureImg(imgUrl);
              inputOnChange(name, imgUrl);
            }}
          ></input>
          <div className={styles.box} onClick={handleLibrary}>
            {title === active ? (
              <img src={thumbnail ? thumbnail : textureImg} alt="material" />
            ) : (
              <TextureIcon style={{width: "24px", height: "24px"}} />
            )}
          </div>
        </label>
      </>
    );
  }
  function ColorPart() {
    return (
      <>
        <div className={`${styles.box} ${styles.color}`} onClick={onClickColorBox}>
          {title === active ? <div style={{background: objectColor}} /> : <ColorIcon style={{width: "24px", height: "24px"}} />}
        </div>
      </>
    );
  }
};

export default BackgroundInput;
